import moment from 'moment'
import Globals from '../Globals'

/**
 * Rapports
 */
const LibRapports = {

    /**
     * Récupère les rapports de l'utilisateur
     * @param etat integer Etat (En cours / Clôturé) Si non précisé => Tous
     * @param dateRelanceMin YYYY-MM-DD Rapports dont la relance est égale à ou après cette date
     * @param dateRelanceMax YYYY-MM-DD Rapports dont la relance est égale à ou avant cette date
     * @param onlyActionsDeFidelisation bool Si true, seulement les rapports non liés à une affaire
     * @param potCommunVendeurs bool Si true, uniquement les actions qui sont dans le pot commun vendeur.
     * @param includeRDVsAtelierToAssign bool Si true, inclure les RDVs atelier à assigner (fonctionne uniquement pour les CDV)
     * @return array
     */
    list: async function (etat: number | null = null, dateRelanceMin: Date | null = null, dateRelanceMax: Date | null = null, onlyActionsDeFidelisation: boolean = false, potCommunVendeurs: boolean | null = null, includeRDVsAtelierToAssign: boolean | null = null, PotCommunCRC: boolean | null = null, MarketingCampaign: boolean | null = null): Promise<[]> {
        try {
            const response = await fetch(localStorage.ClientApiURL + '/actions?Etat=' + etat + '&DateRelanceMin=' + dateRelanceMin + '&DateRelanceMax=' + dateRelanceMax + '&OnlyActionsDeFidelisation='
                + onlyActionsDeFidelisation + '&PotCommunVendeurs=' + potCommunVendeurs + '&IncludeRDVsAtelierToAssign=' + includeRDVsAtelierToAssign + '&PotCommunCRC=' + PotCommunCRC
                + '&MarketingCampaign=' + MarketingCampaign + '&page=0&pageSize=10000', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKey': Globals.API_KEY,
                    'IDClient': localStorage.user_IDClient || '',
                    'Login': localStorage.user_login || '',
                    'Password': localStorage.user_password || '',
                },
            })
        
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.json()
                console.log(error)
                return []
            }
        } catch {
            return []
        }
    },

    /**
     * Récupère les actions de l'utilisteurs (rapports non liés à une affaire)
     * @param IDPeople integer IDPeople de l'utilisateur
     * @param date_relance_debut YYYY-MM-DD Rapports dont la relance est égale à ou après cette date
     * @param date_relance_fin YYYY-MM-DD Rapports dont la relance est égale à ou avant cette date
     * @return array
     */
    async getActions(etat: number, date_relance_debut = null, date_relance_fin = null, potCommunVendeurs: boolean | null = null, includeRDVsAtelierToAssign: boolean | null = null, PotCommunCRC: boolean | null = null, MarketingCampaign: boolean | null = null) {
        return this.list(etat, date_relance_debut, date_relance_fin, true, potCommunVendeurs, includeRDVsAtelierToAssign, PotCommunCRC, MarketingCampaign)
    },

    async getActionsATraiter(etat: number, potCommunVendeurs: boolean | null = null, includeRDVsAtelierToAssign: boolean | null = null) {
        return this.list(etat, moment().format("YYYY-MM-DD"), null, true, potCommunVendeurs, includeRDVsAtelierToAssign)
    },

    async getActionsEnRetard(etat: number, potCommunVendeurs: boolean | null = null, includeRDVsAtelierToAssign: boolean | null = null) {
        return this.list(etat, null, moment().add(-1, 'day').format("YYYY-MM-DD") + "T23:59:59", true, potCommunVendeurs, includeRDVsAtelierToAssign)
    },

    /**
     * Transfert plusieurs rapports/leads à un utilisateur
     * @param Lead lead https://api.e-seller.selectup.com/Help/ResourceModel?modelName=Lead
     * @param int IDPeople Destinataire des rapports/leads
     */
    async transfertManyTo(leads, IDPeople) {
        try {
            const response = await fetch(localStorage.ClientApiURL + '/leads/transferer_many?id_destinataire=' + IDPeople, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKey': Globals.API_KEY,
                    'IDClient': localStorage.user_IDClient,
                    'Login': localStorage.user_login,
                    'Password': localStorage.user_password,
                },
                body: JSON.stringify(leads),
            })
            if (response.ok) {
                return true
            } else {
                const error = await response.json()
                console.log(error)
                return false
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },

    /**
     * Transfert plusieurs rapports/leads à l'utilisateur connecté
     * @param leads lead https://api.e-seller.selectup.com/Help/ResourceModel?modelName=Lead
     */
    async transfertManyToMe(leads: number[]): Promise<boolean> {
        try {
            const response: Response = await fetch(localStorage.ClientApiURL + '/affaires/selfAssignMany', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKey': Globals.API_KEY,
                    'IDClient': localStorage.user_IDClient || '',
                    'Login': localStorage.user_login || '',
                    'Password': localStorage.user_password || '',
                },
                body: JSON.stringify(leads),
            })
            if (response.ok) {
                return true
            } else {
                const error: any = await response.json()
                console.error('API error', error)
                return false
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async transfertManyActionsToMe(actions: string[]) {
        try {
            const response: Response = await fetch(localStorage.ClientApiURL + '/actions/selfAssignMany', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKey': Globals.API_KEY,
                    'IDClient': localStorage.user_IDClient || '',
                    'Login': localStorage.user_login || '',
                    'Password': localStorage.user_password || '',
                },
                body: JSON.stringify(actions),
            })
            if (response.ok) {
                return true
            } else {
                const error: any = await response.json()
                console.error('API error', error)
                return false
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },

    /**
     * Clôturer un ou plusieurs rapports
     * Attention si le rapport est lié à une affaire celle-ci ne sera pas clôturée
     * @param lead lead https://api.e-seller.selectup.com/Help/ResourceModel?modelName=Lead
     */
    async cloturerRapports(leads) {
        try {
            const response = await fetch(localStorage.ClientApiURL + '/leads/cloturer_rapports', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKey': Globals.API_KEY,
                    'IDClient': localStorage.user_IDClient,
                    'Login': localStorage.user_login,
                    'Password': localStorage.user_password,
                },
                body: JSON.stringify(leads),
            })
            if (response.ok) {
                return true
            } else {
                const error = await response.json()
                console.log(error)
                return false
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },
}

export default LibRapports